var map = {
	"./UpgradeSuccess.svg": "ecdf",
	"./bg-img.svg": "0ff9",
	"./bg-ovals.svg": "b6d1",
	"./cognni_logo_captions.svg": "0458",
	"./css/main.scss": "a0d8",
	"./css/mixins.scss": "94ea",
	"./css/prism.css": "f476",
	"./css/screens.scss": "4b7b",
	"./css/tailwind.css": "def6",
	"./dark/empty-watch-list.svg": "972d",
	"./dark/investigate.svg": "d4b4",
	"./dark/no-results.svg": "9c21",
	"./dark/processing.svg": "b925",
	"./dark/stripes-bg.svg": "ef63",
	"./empty-watch-list.svg": "2636",
	"./event-investigation.png": "b1e8",
	"./extra-section-icon.svg": "5779",
	"./investigate.svg": "04ac",
	"./investigation/file1.svg": "ae0d",
	"./investigation/file2.svg": "7668",
	"./investigation/file3.svg": "bc1e",
	"./logo-full.svg": "8c53",
	"./logo-full_dark.svg": "629e",
	"./logo.svg": "9b19",
	"./modal-header-bg.svg": "0c1a",
	"./my-apps/circle-green.svg": "b416",
	"./my-apps/crown-white.svg": "197e",
	"./my-apps/crown.svg": "e94f",
	"./no-results-2.svg": "51d3",
	"./no-results.svg": "b1ac",
	"./oneMoreThing.svg": "bbc2",
	"./overview-widgets/info-risk-widget.png": "78d0",
	"./overview-widgets/information-trust-widget.png": "129b",
	"./overview-widgets/playbooks-widget.png": "456e",
	"./overview-widgets/sensitive-events-widget.png": "8a57",
	"./overview-widgets/total-count-widget.png": "1516",
	"./paypal.png": "dedf",
	"./percentege.svg": "be6d",
	"./placeholder.svg": "ccfb",
	"./popcorn.svg": "1ab5",
	"./premium-toggle.svg": "55d5",
	"./proccess/failure.svg": "29c3",
	"./proccess/success.svg": "299a",
	"./processing.svg": "0fed",
	"./sensitivities/0.svg": "e5d4",
	"./sensitivities/1.svg": "d25e",
	"./sensitivities/2.svg": "097b",
	"./sensitivities/3.svg": "8713",
	"./sensitivities/question.svg": "1b13",
	"./sources/SalesForce.svg": "bba8",
	"./sources/Sharepoint365.svg": "df09",
	"./stripes-bg.svg": "005c",
	"./subject-bg.svg": "147d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";